import BaseReducer from "./BaseReducer";

class ComplianceAlertsReducer extends BaseReducer {
  domain = "Compliance";
  type = "Alerts";

  initialState = {
    activePage: 1,
    alertData: [],
    selectedAlerts: [],
    selectAllAlerts: false,
    alertTypes: [],
    selectedAlertType: null,
    datesRange: "",
    sortColumns: [
      { name: "alertTime", sortDirection: 0, label: "Date & Time" },
      { name: "alertType", sortDirection: 0, label: "Alert Type" },
      { name: "customerName", sortDirection: 0, label: "Name" },
      { name: "customerAge", sortDirection: 0, label: "Age" },
      { name: "position", sortDirection: 0, label: "Position" },
      { name: "machineInstallationNumber", sortDirection: 0, label: "MIN" },
      { name: "netLoss", sortDirection: 0, label: "Net Loss" },
      { name: "timeOnGame", sortDirection: 0, label: "Time on Game" },
      { name: "spend", sortDirection: 0, label: "Spend" },
      { name: "active", sortDirection: 0, label: "Active?" },
    ],
  };
}

const reducer = new ComplianceAlertsReducer();

export default reducer;
